// extracted by mini-css-extract-plugin
module.exports = {"form":"Login_form_26I6H","error":"Login_error_1LjcT","desc":"Login_desc_mYC8r","password":"Login_password_2pyvl","logo":"Login_logo_3tZP2"};